import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cogx',
  templateUrl: './cogx.component.html',
  styleUrls: ['./cogx.component.scss']
})
export class CogxComponent {
  constructor(private dialogRef: MatDialogRef<CogxComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
